<template>
  <main class="main">

    <header>
      <div class="container">
        <nav>
          <div class="logo">
            <img src="@/assets/images/new-logo-mkb.png" alt="">
            <img src="@/assets/images/logo-onlinedoctor.svg" alt="">
          </div>

          <div class="contact">
            <a href="tel:+88003332800">8 800 333 28 00</a>
            <p>Техническая поддержка</p>
          </div>
        </nav>

        <h1>Программы Чекап Онлайн Доктор <span><br>для сотрудников розничной торговли</span></h1>

        <h2>Чекап Онлайн Доктор для сотрудников – это комплекс анализов, который необходимо проходить регулярно, чтобы
          выявлять заболевания на ранних безобидных стадиях
        </h2>
      </div>
    </header>

    <div class="program-description">
      <div class="container">
        <h3>ЧТО ВХОДИТ В ПРОГРАММЫ ЧЕКАП ОНЛАЙН ДОКТОР: </h3>

        <div class="wrapper-item">
          <div class="item">
            <img src="@/assets/images/laboratory.svg" alt="">

            <div class="content">
              <h5>Лабораторные исследования</h5>
            </div>
          </div>

          <div class="item">
            <img src="@/assets/images/consultation.svg" alt="">

            <div class="content">
              <h5>Консультации высококвалифицированных врачей:</h5>
              <p>терапевтов, и врачей узкопрофильных специализаций</p>
            </div>
          </div>

          <div class="item">
            <img src="@/assets/images/like.svg" alt="">

            <div class="content">
              <h5>Инструментальные обследования</h5>
            </div>
          </div>

          <div class="item">
            <img src="@/assets/images/vaccination.svg" alt="">

            <div class="content">
              <h5>Вакцинация</h5>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="checkup-online">
      <div class="container">
        <div class="wrapper-content">
          <div class="left-area">

            <div class="title-block">
              <img src="@/assets/images/doc_checkup.svg" alt="">
              <h3>Чекап Онлайн Доктор</h3>
            </div>

            <p>Программа для 1 взрослого от 18 лет Срок действия программы – 1 год</p>

            <span>750 ₽ за 1 сотрудника</span>
          </div>

          <div class="right-area">
            <h4>СОСТАВ ПРОГРАММЫ:</h4>

            <ul>
              <li>Онлайн-консультации дежурных терапевтов – 4 обращения</li>
              <li>Онлайн-консультации узкопрофильных специалистов по показаниям на выбор: уролог/гинеколог/хирург – 1
                обращение
              </li>
              <li>
                Лабораторные обследования – комплекс анализов однократно:
                <span><br>&#183; ИФА антитела к гепатиту AIg G качественно</span>
                <span><br>&#183; Антитела ВИЧ, HBs Ag, антитела HCV, сифилис</span>
              </li>
              <li>Инструментальные обследования – (комплекс обследований) УЗИ малого таза, УЗДГ вен нижних конечностей
                - однократно
              </li>
              <li>Вакцинация от вируса гепатита А (Альгавак М)</li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div class="employee-connection-request">
      <div class="container">
        <form id="first_form" class="review-form" @submit.prevent="onSubmit">
          <h3>ОТПРАВИТЬ ЗАЯВКУ НА ПОДКЛЮЧЕНИЕ СОТРУДНИКОВ:</h3>

          <input type="text"
                 v-model="name_company"
                 placeholder="Наименование компании"
                 autocomplete="off"
                 required
          />
          <input type="text"
                 v-model="full_name"
                 placeholder="ФИО"
                 autocomplete="off"
                 required
          />
          <input class="tel"
                 type="text"
                 v-model="phone"
                 placeholder="+7"
                 autocomplete="off"
                 max="11"
                 required
          />
          <button>Отправить</button>
        </form>
      </div>
    </div>

    <div class="advantage-of-consultation employee">
      <div class="container">
        <div class="wrapper-content">

          <div class="image-block">
            <img src="@/assets/images/consultation_bg.svg" alt="">
          </div>

          <div class="description-block">
            <p>
              Консультации с врачами по результатам обследований (расшифровка анализов,
              интерпретация результатов обследований, заключение) проходят в дистанционном
              режиме:
            </p>

            <div class="wrapper-item">
              <div class="item">
                <img src="@/assets/images/employee-health.svg" alt="">
                <p>Через компьютер или мобильное приложение сервиса дистанционных консультаций с врачами Онлайн
                  Доктор</p>
              </div>

              <div class="item">
                <img src="@/assets/images/crown.svg" alt="">
                <p>Круглосуточно <br> и без выходных</p>
              </div>

              <div class="item">
                <img src="@/assets/images/restore-health.svg" alt="">
                <p>В режиме реального времени <br> с терапевтами</p>
              </div>

              <div class="item">
                <img src="@/assets/images/heat.svg" alt="">
                <p>В режиме реального времени <br> с терапевтами</p>
              </div>

              <div class="item">
                <img src="@/assets/images/disease.svg" alt="">
                <p>По предварительной записи с <br> узкопрофильными специалистами</p>
              </div>
            </div>

            <div class="advantage">
              <h4>В РЕЗУЛЬТАТЕ КОНСУЛЬТАЦИИ</h4>

              <div class="item">
                <img src="@/assets/images/checkbox.svg" alt="">
                <p>Реже болеют и отпрашиваются с работы</p>
              </div>

              <div class="item">
                <img src="@/assets/images/checkbox.svg" alt="">
                <p> Лояльны к компании, реже увольняются</p>
              </div>
            </div>
          </div>

        </div>

      </div>
    </div>

    <div class="learn-more">
      <div class="container">
        <form id="second_form" class="review-form" @submit.prevent="onSubmit">
          <h3>УЗНАТЬ ПОДРОБНЕЕ ОБ УСЛУГЕ:</h3>

          <input type="text"
                 v-model="full_name"
                 placeholder="ФИО"
                 autocomplete="off"
                 required
          />
          <input class="tel"
                 type="text"
                 v-model="phone"
                 placeholder="+7"
                 autocomplete="off"
                 max="11"
                 required
          />
          <button>Отправить</button>
        </form>
      </div>
    </div>

    <div class="advantage-of-consultation">
      <div class="container">
        <div class="wrapper-content">

          <div class="image-block">
            <img src="@/assets/images/consultation-doctor.svg" alt="">
          </div>

          <div class="description-block">
            <p>
              Консультации с врачами по результатам обследований (расшифровка анализов,
              интерпретация результатов обследований, заключение) проходят в дистанционном
              режиме:
            </p>

            <div class="wrapper-item">
              <div class="item">
                <img src="@/assets/images/phone.svg" alt="">
                <p>Через компьютер или мобильное приложение сервиса дистанционных консультаций с врачами Онлайн
                  Доктор</p>
              </div>

              <div class="item">
                <img src="@/assets/images/time.svg" alt="">
                <p>Круглосуточно <br> и без выходных</p>
              </div>

              <div class="item">
                <img src="@/assets/images/doctor.svg" alt="">
                <p>В режиме реального времени <br> с терапевтами</p>
              </div>

              <div class="item">
                <img src="@/assets/images/pen.svg" alt="">
                <p>По предварительной записи с <br> узкопрофильными специалистами</p>
              </div>
            </div>

            <div class="advantage">
              <h4>В РЕЗУЛЬТАТЕ КОНСУЛЬТАЦИИ</h4>

              <p>
                пациент получает письменное заключение врача и подробные
                рекомендации по лечению, реабилитации и профилактике здоровья
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="reversal-algorithm">
      <div class="container">
        <h3>КАК ВОСПОЛЬЗОВАТЬСЯ УСЛУГОЙ:</h3>

        <div class="wrapper-item">

          <div class="item">
            <div class="header-item">
              <h4>1/3</h4>
              <img src="@/assets/images/line.svg" alt="">
            </div>

            <p>
              Пациент обращается к дежурному врачу-терапевту в сервисе
              Онлайн Доктор или в чат «Отдела заботы» или по телефону
              <a href="tel:+88003332800">8 800 333 28 00</a>
            </p>
          </div>

          <div class="item">
            <div class="header-item">
              <h4>2/3</h4>
              <img src="@/assets/images/line.svg" alt="">
            </div>

            <p>
              Врач или ассистент сервиса направляет на обследование
            </p>
          </div>

          <div class="item">
            <div class="header-item">
              <h4>3/3</h4>
              <img src="@/assets/images/checkbox.svg" alt="">
            </div>

            <p>
              По результатам анализов пациент может проконсультироваться снова
              с дежурным терапевтом либо записаться на онлайн-консультацию к
              узкопрофильному специалисту
            </p>
          </div>

        </div>
      </div>
    </div>

    <footer>
      <div class="container">
        <form id="third_form" class="review-form" @submit.prevent="onSubmit">
          <h3>ОТПРАВИТЬ ЗАЯВКУ НА ПОДКЛЮЧЕНИЕ СОТРУДНИКОВ:</h3>

          <input type="text"
                 v-model="name_company"
                 placeholder="Наименование компании"
                 autocomplete="off"
                 required
          />
          <input type="text"
                 v-model="full_name"
                 placeholder="ФИО"
                 autocomplete="off"
                 required
          />
          <input type="text"
                 class="tel"
                 v-model="phone"
                 placeholder="+7"
                 autocomplete="off"
                 max="11"
                 required
          />
          <button type="submit">Отправить</button>
        </form>
      </div>
    </footer>

    <div id="successModal" class="modal">
      <div class="modal-dialog">
        <div class="modal-content">
          <p>Ваша заявка отправлена!</p>
        </div>
      </div>
    </div>

    <div id="errorModal" class="modal">
      <div class="modal-dialog">
        <div class="modal-content">
          <p>При отправке заявки возникла ошибка!</p>
        </div>
      </div>
    </div>

  </main>
</template>

<script>
import './style.css'
import '../../assets/fonts/stylesheet.css'
import '../../assets/js/yandex-metrika'
import '../../assets/js/common.js'

import axios from 'axios'

export default {
  name: 'MkbRetailLanding',

  data() {
    return {
      name_company: null,
      full_name: null,
      phone: null,
    }
  },

  methods: {
    onSubmit: function () {
      var formData = this.$data
      var stringJson = JSON.stringify(formData);
      var parsedObject = JSON.parse(stringJson);
      var form

      form =
          "Лендинг МКБ для сотрудников розничной торговли" + "\n\n" +
          "Имя компании: " + parsedObject.name_company + "\n" +
          "ФИО: " + parsedObject.full_name + "\n" +
          "Телефон: " + parsedObject.phone + "\n"

      axios.post('https://onlinedoctor.ru/mobile/repeater/send/', {
        receiver: 'd2a524d75ad4f9876746de50d0b96d13',
        text: `${form}`
      })
          .then(function (response) {
            const modal = document.querySelector('#successModal');

            modal.classList.add('success');
            console.log(response);

            setTimeout(function () {
              location.reload();
            }, 3000);
          })
          .catch(function (error) {
            const modal = document.querySelector('#errorModal');
            modal.classList.add('error');
            console.log(error);
          });
    },
  },
}
</script>
